import { getHexToRgb, transitionAnimation } from 'lib/core';
import { css } from 'styled-components';

import { getButtonContentElementsColor } from '../../shared-styles';

const focusOutlineColors = {
  getDark: (theme, opacity = 0.5) => `rgba(${getHexToRgb(theme.color.additional.dark.value)}, ${opacity})`,
  getLight: (theme, opacity = 0.5) => `rgba(${getHexToRgb(theme.color.additional.light.value)}, ${opacity})`,
  getPrimary: (theme, opacity = 0.5) => `rgba(${getHexToRgb(theme.color.button.focusBaseColor.value)}, ${opacity})`,
};

const focusOutlinesStyles = {
  dark: css`
    outline: 4px solid ${({ theme }) => focusOutlineColors.getDark(theme)};
    ${transitionAnimation('outline')}
  `,
  light: css`
    outline: 4px solid ${({ theme }) => focusOutlineColors.getLight(theme)};
    ${transitionAnimation('outline')}
  `,
  primary: css`
    outline: 4px solid ${({ theme }) => focusOutlineColors.getPrimary(theme)};
    ${transitionAnimation('outline')}
  `,
};

const fabLightBackgroundStates = {
  active: css`
    background-color: ${({ theme }) => theme.color.button.primary.background.active.value};
    ${({ theme }) => getButtonContentElementsColor(theme.color.additional.alwaysWhite.value)}
  `,
  default: css`
    background-color: ${({ theme }) => theme.color.button.primary.background.enabled.value};
    ${({ theme }) => getButtonContentElementsColor(theme.color.additional.alwaysWhite.value)}
  `,
  disabled: css`
    background-color: ${({ theme }) => theme.color.state.primary.disabled.value};
    ${({ theme }) => getButtonContentElementsColor(theme.color.text.light.disabled.value)};
  `,
  focus: css`
    background-color: ${({ theme }) => theme.color.button.primary.background.hover.value};
    ${({ theme }) => getButtonContentElementsColor(theme.color.additional.alwaysWhite.value)}
    ${focusOutlinesStyles.primary};
  `,
  hover: css`
    background-color: ${({ theme }) => theme.color.button.primary.background.hover.value};
    ${({ theme }) => getButtonContentElementsColor(theme.color.additional.alwaysWhite.value)}
  `,
};

const fabPrimaryBackgroundStates = {
  active: css`
    background-color: ${({ theme }) => theme.color.primary[200].value};
    ${({ theme }) => getButtonContentElementsColor(theme.color.primary[700].value)}
  `,
  default: css`
    background-color: ${({ theme }) => theme.color.additional.light.value};
    ${({ theme }) => getButtonContentElementsColor(theme.color.primary[500].value)}
  `,
  disabled: css`
    background-color: ${({ theme }) => theme.color.state.primary.disabled.value};
  `,
  focus: css`
    background-color: ${({ theme }) => theme.color.primary[100].value};
    ${focusOutlinesStyles.light};
    ${({ theme }) => getButtonContentElementsColor(theme.color.primary[600].value)}
  `,
  hover: css`
    background-color: ${({ theme }) => theme.color.primary[100].value};
    ${({ theme }) => getButtonContentElementsColor(theme.color.primary[600].value)}
  `,
};

export const fabStateStyles = {
  default: fabLightBackgroundStates,
  defaultOnPrimaryBackground: fabPrimaryBackgroundStates,
};

export const getStateStyles = (isOnPrimaryBackground) => {
  return isOnPrimaryBackground ? fabStateStyles.defaultOnPrimaryBackground : fabStateStyles.default;
};
